






































































import { CaseWithMessages } from '@/queries/cases.graphql'
import DatePicker from '@/components/workflow/Datepicker.vue'
import { MyInterviewOffers } from './ResetAppointment.graphql'
import moment from 'moment'

export default {
  computed: {
    completable() {
      return (
        // external link is given
        this.externalLink &&
        this.externalLink.trim() !== '' &&
        // existing offer is given
        (this.useOfferId ||
          // or new date is given as string
          (typeof this.newDate === 'string' && this.newDate.trim() !== '') ||
          // or new date is given as date
          this.newDate instanceof Date)
      )
    },
    options() {
      const offers = [
        { value: null, text: 'Choose existing offer' },
        ...this.offers.nodes
          .filter(offer => offer.activeBookings.nodes.length === 0)
          .map(offer => ({
            value: offer.id,
            text: `${moment(offer.timeSlot.start.value).format('YYYY-MM-DD HH:mm')} til ${moment(
              offer.timeSlot.end.value
            ).format('YYYY-MM-DD HH:mm')}`,
          })),
      ]
      return offers
    },
    patientAlias() {
      const thisCase = this.pickedCase
      if (thisCase) {
        return thisCase.patient.alias
      } else {
        return 'error unknown case'
      }
    },
  },
  apollo: {
    offers: {
      query: MyInterviewOffers,
      variables() {
        return {
          interviewerId: this.$store.getters.currentUserId,
        }
      },
    },
    pickedCase: {
      query: CaseWithMessages,
      variables() {
        return {
          id: this.case_id,
        }
      },
    },
  },
  components: {
    DatePicker,
  },
  data() {
    return {
      newDate: this.value.newDate || '',
      abandon: this.value.abandon || false,
      useOfferId: this.value.useOfferId || null,
      externalLink: this.value.externalLink || '',
      offers: { nodes: [] },
    }
  },
  props: {
    caseId: {
      required: true,
      type: String,
    },
    value: {
      required: true,
      type: Object,
    },
  },
  methods: {
    confirm() {
      return window.confirm('Are you sure?')
    },
  },
  watch: {
    useOfferId(newOfferId, oldOfferId) {
      if (newOfferId) {
        console.log(this.offers.nodes)
        this.offers.nodes
          .filter(offer => offer.id === newOfferId)
          .forEach(offer => (this.externalLink = offer.externalLink || this.externalLink))
      }
    },
  },
}
